import { HttpStatus } from '@nestjs/common';

export abstract class MezoException extends Error {
  status: HttpStatus;
}
